import React, {useEffect} from "react";
import {Button, Dialog, DialogTitle, Stack} from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import {DocumentScanner} from '@uziee/document-scanner';

export default function ContractScannerDialog({
                                                  open,
                                                  onClose,
                                                  showScanner,
                                                  setShowScanner,
                                                  scannedImages,
                                                  clearContent,
                                                  onCapture,
                                                  signedContractPdf,
                                                  onPdfChange,
                                                  signedContractInputRef,
                                                  onUpload
                                              }) {

    useEffect(() => {
        if (!showScanner && window.activeCameraTracks && window.activeCameraTracks.length > 0) {
            window.activeCameraTracks.forEach(track => track.stop());
            window.activeCameraTracks = [];
        }

        return () => {
            if (window.activeCameraTracks) {
                window.activeCameraTracks.forEach(track => track.stop());
                window.activeCameraTracks = [];
            }
        };
    }, [showScanner]);

    return (
        <Dialog fullWidth open={open} sx={{p: 2}} onClose={onClose}>
            <DialogTitle>Scanner le contrat</DialogTitle>

            <Stack sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', px: 2, pb: 2}}
                   direction="row" spacing={2}>
                <input
                    type="file"
                    accept="application/pdf"
                    ref={signedContractInputRef}
                    style={{display: 'none'}}
                    onChange={onPdfChange}
                />

                <Button onClick={() => signedContractInputRef.current.click()} variant="outlined"
                        sx={{mb: 2, mx: 2}} startIcon={<UploadIcon/>}>
                    Depuis vos fichiers
                </Button>

                <Button onClick={() => {
                    clearContent();
                    setShowScanner(true);
                }} variant="contained"
                        sx={{mb: 2, mx: 2}} startIcon={<CameraAltIcon/>}>
                    {scannedImages.length > 0 ? "Relancer le scan" : "Lancer le scan"}
                </Button>
            </Stack>

            {showScanner &&
                <DocumentScanner
                    onCapture={onCapture}
                    onClose={() => setShowScanner(false)}
                />
            }

            {scannedImages.map((img, i) => (
                <img key={i} src={img} alt={`Scanned document ${i + 1}`}
                     style={{width: "100%", marginTop: 10}}/>
            ))}

            {signedContractPdf != null &&
                <iframe
                    src={URL.createObjectURL(signedContractPdf)}
                    width="100%"
                    height="600px"
                    style={{border: 'none', display: 'block'}}
                    title="Aperçu PDF"
                />
            }

            {(scannedImages.length > 0 || signedContractPdf != null) &&
                <Button variant="contained" sx={{m: 2}} onClick={onUpload}>
                    Valider
                </Button>
            }
        </Dialog>
    );
}
